module.exports = __webpack_public_path__ + "media/images/share-whatsapp-a4336842e1ed87ffc5a87918b0feb1bf.svg";